import { render, staticRenderFns } from "./PersonPage.vue?vue&type=template&id=13dcdc93&scoped=true"
import script from "./PersonPage.vue?vue&type=script&lang=js"
export * from "./PersonPage.vue?vue&type=script&lang=js"
import style0 from "./PersonPage.vue?vue&type=style&index=0&id=13dcdc93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dcdc93",
  null
  
)

export default component.exports